import { render, staticRenderFns } from "./Recycler.vue?vue&type=template&id=2c796391&lang=pug"
import script from "./Recycler.vue?vue&type=script&lang=js"
export * from "./Recycler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports